export const allTeamsValue = '*';

export const minIncomeToLive = {
  singleWithoutChildren: 564.78,
  coupleWithoutChildren: 847.17,
  singleWithOneChild: 847.17,
  coupleWithOneChild: 1016.6,
  singleWithTwoChildren: 1016.6,
  coupleWithTwoChildren: 1186.04,
  singleAdditionalPerson: 225.91,
  coupleAdditionalPerson: 225.91,
};
